import React, { useMemo, useState, useCallback, useRef, useEffect } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { Tooltip, Menu } from 'antd';
import Alert from '@web-common/components/UI/Alert/Alert';
import { FLOLDER, MAIL_SEARCH_FILTER } from '../../common/constant';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { useActions, useAppDispatch, MailActions, useAppSelector, MailClassifyActions } from '@web-common/state/createStore';
import { apiHolder as api, apis } from 'api';
import { actions as mailTabActions, tabType } from '@web-common/state/reducer/mailTabReducer';
import FolderSortModal from '@web-mail/components/FolderSortModal/FolderSortModal';
import WmFolderSortModal from '@web-mail/components/WmFolderSortModal/WmFolderSortModal';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import { isObject } from 'lodash';
import Badge from '@web-common/components/UI/SiriusBadge';
import { isFollowFolder, isUnFollowFolder } from '@web-mail/util';
import { useLocation } from '@reach/router';
import moment from 'moment';
import { TongyongShuomingMian } from '@sirius/icons';
import debounce from 'lodash/debounce';
import lodashGet from 'lodash/get';
import { jumpToContactPersonalMark } from '@web-common/utils/contact_util';
import { validateFolderOperForNode } from '../../state/customize';
import { treeDFS, getTreeNodeById, isCustomFolder, folderId2String, folderId2Number, mailLogicStateIsMerge, mailConfigStateIsMerge, getMainAccount, isMainAccount, folderIdIsContact, isSystemFolder, folderIdIsRealFolder, dragTransFileHasEml, getEmlFileFromDragTrans, importMails, getMapConfigBySameAccountKey, getParentNodeById, folderIdIsAllFolder, getTreeStatesByAccount, isCustomerUnFollowFolder, } from '../../util';
import useUserLocalStorageState from '@web-mail/hooks/useUserLocalStorageState';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import useState2RM from '../../hooks/useState2ReduxMock';
import useStateRef from '@web-mail/hooks/useStateRef';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { MailTag } from '../MailTagList/MailTag';
import SiriusCollapse from '@web-mail/components/SiriusCollapse';
import FolderTree from './FolderTree';
import MultAccountsLoginModal from '@web-common/components/UI/MultAccountsLoginModal';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = api.api.getSystemApi();
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const inElectron = systemApi.isElectron();
const storageApi = api.api.getDataStoreApi();
const EDM_REPLY_TIP_ALLFOLDER = 'EDM_REPLY_TIP_ALLFOLDER';
const HAVE_EDM_REPLY_TIP_ALLFOLDER = 'HAVE_EDM_REPLY_TIP_ALLFOLDER';
const getCount = (treeMap, isMerge = false) => {
    var _a;
    if (!treeMap) {
        return 0;
    }
    let count = 0;
    const ignoreFolder = [FLOLDER.DRAFT, FLOLDER.UNREAD, FLOLDER.DEFER, FLOLDER.STAR, FLOLDER.SPAM];
    (_a = treeMap === null || treeMap === void 0 ? void 0 : treeMap.mailFolderTreeList) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
        var _a, _b, _c;
        if (item && !ignoreFolder.includes((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId)) {
            count += isMerge ? (_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.threadMailBoxCurrentUnread : (_c = item === null || item === void 0 ? void 0 : item.entry) === null || _c === void 0 ? void 0 : _c.mailBoxUnread;
        }
    });
    return count;
};
const MailFolders = props => {
    const { uploadFileRef, className = '' } = props;
    const location = useLocation();
    const _uploadFileRef = useStateRef(uploadFileRef.current);
    const dispatch = useAppDispatch();
    const reducer = useActions(MailActions);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const [loginingSubAccountList] = useState2RM('loginingSubAccountList', 'doUpdateLoginingSubAccountList');
    const [expiredAccountList] = useState2RM('expiredAccountList', 'doUpdateExpiredAccountList');
    const [mailTreeStateMap, setTreeState] = useState2RM('mailTreeStateMap', 'doUpdateMailTreeState');
    const [tagName] = useState2RM('mailTagFolderActiveKey');
    const [mailSearchAccount] = useState2RM('mailSearchAccount', 'doUpdateMailSearchAccount');
    const [folderTreeDragModel] = useState2RM('folderTreeDragModel');
    const [, setSelected] = useState2RM('', 'doUpdateMailListStateTab');
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const [expandedSearchKeys] = useState2RM('expandedSearchKeys', 'doUpdateExpandedSearchKeys');
    const [selectedSearchKeys] = useState2RM('selectedSearchKeys', 'doUpdateSelectedSearchKey');
    const [, setFolderModveModalVisiable] = useState2RM('', 'doUpdateFolderModveModalVisiable');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [isDragModel] = useState2RM('isDragModel');
    const [, setDialog] = useState2RM('', 'doUpdatedialogConfig');
    const [, setModalVisible] = useState2RM('', 'doUpdateCommonModalVisible');
    const [, setAddContactModelVisiable] = useState2RM('addContactModelVisiable');
    const [mailSearchStateMap] = useState2RM('mailSearchStateMap', 'doUpdateMailSearchStateMap');
    const [, setFolderMoveId] = useState2RM('', 'doUpdateFolderMoveId');
    const [, setImportFolderId] = useState2RM('', 'doUpdateImportFolderId');
    const { setMailFolderId, changeShowClassifyModal, setModalAccount } = useActions(MailClassifyActions);
    const [keepPeriod] = useState2RM('keepPeriod', 'doUpdateKeepPeriod');
    const [folderSortModalVisiable, setFolderSortModalVisiable] = useState2RM('folderSortModalVisiable', 'doUpdateFolderSortModalVisiable');
    const [folderSortModalData, setFolderSortModalData] = useState2RM('folderSortModalData', 'doUpdateFolderSortData');
    const [multAccountsLoginVisible, setMultAccountsLoginVisible] = useState(false);
    const [multAccountsLoginInfo, setMultAccountsLoginInfo] = useState({ type: 'bind', way: 'mailSetting' });
    const mailTreeStateMapRef = useRef(mailTreeStateMap);
    mailTreeStateMapRef.current = mailTreeStateMap;
    const [showStarFolderTag, setShowStarFolderTag] = useUserLocalStorageState('showStarFolderTag', true);
    const [activeKey, setActiveKey] = useState2RM('accountActiveKey', 'doUpdateAccountActiveKey');
    const [mainMailHasCustomFolder, setMailMailHasCtFolder] = useState(true);
    const folderRefMap = useRef({});
    const md = useRef();
    const treeContainerRef = useRef(null);
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const curTabIsReadTab = useMemo(() => currentTabType === tabType.read, [currentTabType]);
    const isMailDraging = useMemo(() => folderTreeDragModel != null, [folderTreeDragModel]);
    const maiTreeStateList = useMemo(() => {
        const arr = [];
        Object.keys(mailTreeStateMap).forEach(key => {
            if (key === 'main') {
                const count = getCount(mailTreeStateMap.main, mailConfigStateIsMerge());
                arr[0] = Object.assign(Object.assign({}, mailTreeStateMap.main), { accountId: getMainAccount(), count });
            }
            else {
                const index = mailTreeStateMap[key].sort;
                const count = getCount(mailTreeStateMap[key]);
                arr[index] = Object.assign(Object.assign({}, mailTreeStateMap[key]), { accountId: key, count });
            }
        });
        return arr;
    }, [mailTreeStateMap]);
    const maiTreeStateListReal = useMemo(() => {
        return maiTreeStateList.filter(maiTreeState => {
            const { initLoading, expired, mailFolderTreeList } = maiTreeState;
            if (initLoading || expired || !mailFolderTreeList.length) {
                return false;
            }
            return true;
        });
    }, [maiTreeStateList]);
    const edmReplyCount = useRef(1);
    useEffect(() => {
        if (location.hash.indexOf('#mailbox') !== -1) {
            edmReplyCount.current = 1;
        }
    }, [location.hash]);
    useEffect(() => {
        let md;
        try {
            if (location.hash.indexOf('#mailbox') !== -1) {
                accountApi.getMainAndSubAccounts({ expired: false }).then(allAccounts => {
                    var _a, _b;
                    const haveTipsEdmReply = Boolean(((_a = storageApi.getSync(HAVE_EDM_REPLY_TIP_ALLFOLDER)) === null || _a === void 0 ? void 0 : _a.data) === '1') || false;
                    const allAccountsLength = allAccounts.length;
                    if (maiTreeStateListReal.length === allAccountsLength && !haveTipsEdmReply && !!edmReplyCount.current) {
                        const dayKey = moment().format('YYYY-MM-DD');
                        const edmReplyTipInfo = JSON.parse(((_b = storageApi.getSync(EDM_REPLY_TIP_ALLFOLDER)) === null || _b === void 0 ? void 0 : _b.data) || '{}');
                        if (edmReplyTipInfo && edmReplyTipInfo[dayKey]) {
                            return;
                        }
                        else {
                        }
                        let unReadTotal = 0;
                        maiTreeStateList.forEach(s => {
                            var _a;
                            unReadTotal += ((_a = s.MailFolderTreeMap[FLOLDER.EDM_REPLY]) === null || _a === void 0 ? void 0 : _a.entry.mailBoxUnread) || 0;
                        });
                        if (unReadTotal >= 3 && currentTabType === tabType.readMain) {
                            storageApi.putSync(EDM_REPLY_TIP_ALLFOLDER, JSON.stringify({
                                [dayKey]: true,
                            }));
                            storageApi.putSync(HAVE_EDM_REPLY_TIP_ALLFOLDER, '1');
                            edmReplyCount.current = 0;
                            md = SiriusModal.confirm({
                                title: getIn18Text('NINDEYOUXXYDTWDDYXQK18'),
                                hideCancel: true,
                                content: null,
                                cancelText: getIn18Text('SHAOHOUZAISHUO'),
                                okText: getIn18Text('QUCHAKAN'),
                                icon: React.createElement(TongyongShuomingMian, { wrapClassName: "wm-reply-tip-icon", style: { width: 18, height: 18, color: '#4c6aff' } }),
                                onOk: () => {
                                    storageApi.putSync(HAVE_EDM_REPLY_TIP_ALLFOLDER, '0');
                                    setSelectedKeys({
                                        id: FLOLDER.ALL_EDM_REPLY,
                                    });
                                    md && md.destroy && md.destroy();
                                },
                                onCancel: () => {
                                    md && md.destroy && md.destroy();
                                    storageApi.putSync(HAVE_EDM_REPLY_TIP_ALLFOLDER, '0');
                                },
                            });
                        }
                    }
                });
            }
        }
        catch (e) { }
        return () => {
            md && md.destroy && md.destroy();
        };
    }, [maiTreeStateListReal, location.hash]);
    const mailUnReadSum = useMemo(() => {
        let sum = 0;
        maiTreeStateList.forEach(item => {
            if (item === null || item === void 0 ? void 0 : item.count) {
                sum += item.count;
            }
        });
        return sum;
    }, [maiTreeStateList]);
    const isMerge = useCallback(() => mailLogicStateIsMerge(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, isSearching), [selectedKeys, isSearching]);
    const doMailAllDelete = useCallback((fid, accountId) => {
        if (fid) {
            return dispatch(Thunks.doMailAllDelete({
                fid,
                accountId,
            }));
        }
        return Promise.reject();
    }, []);
    const getDeletDialogConfig = useCallback((node) => {
        const fid = node.entry.mailBoxId;
        const accountId = node._account || '';
        if (fid === 4) {
            return {
                title: getIn18Text('QUEDINGCHEDIQINGK“YSC”ZZJFYJM？', { count: node === null || node === void 0 ? void 0 : node.entry.mailBoxTotal }),
                okText: getIn18Text('CHEDIQINGKONG'),
                danger: true,
                onOk: () => doMailAllDelete(fid, accountId),
                content: getIn18Text('CHEDIQINGKONGDE'),
                okButtonProps: { 'data-test-id': 'folder-complete-empty-modal-ok' },
            };
        }
        const getTitle = () => (React.createElement("div", { style: { display: 'inline-flex', maxWidth: '375px' } },
            React.createElement("span", null, getIn18Text('QUEDINGQINGKONG“')),
            React.createElement("span", { style: {
                    flex: 1,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                } }, node === null || node === void 0 ? void 0 : node.entry.mailBoxName),
            React.createElement("span", null,
                getIn18Text('”ZHONGDE'), node === null || node === void 0 ? void 0 :
                node.entry.mailBoxTotal,
                getIn18Text('FENGYOUJIANMA？'))));
        return {
            title: getTitle(),
            okText: getIn18Text('QINGKONG'),
            danger: true,
            onOk: () => doMailAllDelete(fid, accountId),
            content: getIn18Text('QINGKONGDEYOUJIANJZCZ“YSC”WJJZT', { keepPeriod }),
            okButtonProps: { 'data-test-id': 'folder-empty-modal-ok' },
        };
    }, [doMailAllDelete]);
    const treeContainerScrollController = useCallback((top) => {
        if (treeContainerRef.current != null && treeContainerRef.current.scrollBy) {
            treeContainerRef.current.scrollBy({
                top,
            });
        }
    }, []);
    const handleSwitchTab = useCallback((folder) => {
        var _a;
        let title = (_a = folder === null || folder === void 0 ? void 0 : folder.entry) === null || _a === void 0 ? void 0 : _a.mailBoxName;
        const mailTabModel = {
            id: '-1',
            title,
            type: tabType.readMain,
            closeable: false,
            isActive: true,
            extra: {
                accountId: folder === null || folder === void 0 ? void 0 : folder._account,
            },
        };
        dispatch(mailTabActions.doSetTab(mailTabModel));
    }, []);
    const openMailSetting = useCallback((_account, id) => {
        const userData = systemApi.getCurrentUser(_account);
        if (userData) {
            const { loginAccount, id: userId } = userData;
            setModalAccount(loginAccount || userId || '');
            setMailFolderId(id);
            changeShowClassifyModal(true);
            trackApi.track('pcMail_view_mailClassificationNewPage', { type: 'folder' });
        }
    }, []);
    const handleAllRead = useCallback((fid, accountId) => {
        reducer.updateAllReadLoading({
            accountId: accountId,
            folderId: fid,
            loading: true,
        });
        return dispatch(Thunks.doActiveFolderAllRead({
            folderId: fid,
            isThread: isMerge(),
            accountId,
        }))
            .unwrap()
            .finally(() => {
            reducer.updateAllReadLoading({
                accountId: accountId,
                folderId: fid,
                loading: false,
            });
        });
    }, [isMerge]);
    const handleAllFollow = useCallback((fid, accountId) => {
        return dispatch(Thunks.doActiveFolderAllFollow({
            account: [accountId],
            customerEmail: isCustomerUnFollowFolder(fid),
        }));
    }, []);
    const renderUnread = useCallback((node, unRead) => {
        if (node.mailBoxId === FLOLDER.DEFER) {
            return unRead ? (React.createElement("span", { className: `u-unread ${node.mailBoxId === FLOLDER.DEFER ? 'u-undone' : ''}` },
                node.mailBoxId === FLOLDER.DEFER ? getIn18Text('JINRI') : '',
                unRead)) : null;
        }
        if (node.mailBoxId === FLOLDER.STAR && showStarFolderTag) {
            return React.createElement(Badge, { intro: getIn18Text('XINGOGNNENG'), style: { marginRight: 10 } });
        }
        if (node.mailBoxId === FLOLDER.DRAFT) {
            return (React.createElement("span", { className: "u-unread", "data-test-id": "mail-folder-unread" }, node.entry.mailBoxTotal));
        }
    }, [showStarFolderTag]);
    const handleEmlDrop = useCallback((event, fid, accountId) => {
        event.preventDefault();
        const uploadFileList = getEmlFileFromDragTrans(event);
        if (uploadFileList.length) {
            importMails({ fid: Number(fid), fileList: uploadFileList, _account: accountId }, true).then(() => {
                setTimeout(() => {
                    dispatch(Thunks.refreshMailList({
                        noCache: true,
                        showLoading: false,
                    }));
                }, 1500);
            });
        }
        reducer.updateOuterFileDragLeave({});
    }, []);
    const handleTreeItemDrop = useCallback((e, folderId, folderAccount) => {
        e.persist();
        const idlist = e.dataTransfer.getData('text').split(',');
        const isThread = e.dataTransfer.getData('isThread') == 'true';
        const accountId = e.dataTransfer.getData('accountId');
        if (folderAccount == accountId) {
            dispatch(Thunks.doMoveMail({
                mailId: idlist,
                folderId,
                showLoading: true,
                accountId,
            }));
        }
        else {
            Message.warn({
                content: getIn18Text('GAIYOUJIANBUSHUYDQZH'),
            });
        }
    }, []);
    const handleFolderTreeMenuClick = useCallback(() => {
        trackApi.track('pcMail_clickOption_rightKey_folderList');
    }, []);
    const handleMoveFolder = useCallback((node) => {
        setFolderMoveId({
            folderId: node.entry.mailBoxId,
            accountId: node._account,
        });
        setFolderModveModalVisiable(true);
    }, []);
    const handleImportFolder = useCallback((node) => {
        setImportFolderId({
            folderId: node.entry.mailBoxId,
            accountId: node._account,
        });
    }, []);
    const handleSwitchFolder = useCallback(debounce((node) => {
        var _a, _b, _c;
        if (node) {
            let key = ((_a = selectedSearchKeys[mailSearchAccount]) === null || _a === void 0 ? void 0 : _a.folder) || FLOLDER.SEARCH_ALL_RESULT;
            console.log('[FolderTree] 选择文件夹 handleSwitchFolder:', key, Date.now());
            const account = (node === null || node === void 0 ? void 0 : node._account) || mailSearchAccount;
            if (node.entry) {
                const { mailBoxId, mailBoxName } = node.entry;
                key = mailBoxId;
                const folderName = mailBoxName;
                if (isSearching) {
                    trackApi.track('pcMail_select_leftOptions_mailSearchResultPage', {
                        filtratesName: '文件夹筛选',
                    });
                }
                else {
                    if (key != FLOLDER.OTHERS && key != FLOLDER.TAG && key != FLOLDER.STAR) {
                        try {
                            const isContant = folderIdIsContact(key);
                            let trackFolderName = folderName;
                            let trackFolderKey = key;
                            if (isContant) {
                                trackFolderKey = FLOLDER.STAR;
                                trackFolderName = getIn18Text('markContact');
                            }
                            else {
                                if (key >= 100) {
                                    trackFolderName = getIn18Text('ZIDINGYIWENJIAN');
                                }
                            }
                            accountApi.getMainAndSubAccounts({ expired: false }).then(accounts => {
                                trackApi.track('pcMail_switch_folder_folderList', {
                                    folderType: trackFolderKey,
                                    folderTypeName: trackFolderName,
                                    agentNumber: accounts && accounts.length > 1 ? accounts.length - 1 : 0,
                                });
                            });
                        }
                        catch (err) {
                            console.error(err);
                        }
                    }
                }
            }
            reducer.doSwitchFolder({
                id: key,
                accountId: account,
                authAccountType: node === null || node === void 0 ? void 0 : node.authAccountType,
            });
            if (isSearching) {
                if (!(node === null || node === void 0 ? void 0 : node.entry)) {
                    let filterKey = '';
                    if (isObject((_b = node === null || node === void 0 ? void 0 : node.filterCond) === null || _b === void 0 ? void 0 : _b.operand)) {
                        filterKey = Object.keys(node.filterCond.operand)[0];
                    }
                    else {
                        filterKey = (_c = node === null || node === void 0 ? void 0 : node.filterCond) === null || _c === void 0 ? void 0 : _c.field;
                    }
                    trackApi.track('pcMail_select_leftOptions_mailSearchResultPage', {
                        filtratesName: MAIL_SEARCH_FILTER[filterKey],
                    });
                }
                if ((node === null || node === void 0 ? void 0 : node.entry) && lodashGet(node, 'children.length', 0) > 0) {
                    const parentCount = lodashGet(node, 'entry.mailBoxUnread', 0);
                    const childrenCount = (node.children || []).reduce((prev, cur) => prev + lodashGet(cur, 'entry.mailBoxUnread', 0), 0);
                    if (parentCount === childrenCount && (node === null || node === void 0 ? void 0 : node.mailBoxId) && !expandedSearchKeys.includes(node.mailBoxId)) {
                        const expandList = [...expandedSearchKeys];
                        expandList.push(node.mailBoxId);
                        expandFolder(expandList);
                    }
                }
                dispatch(Thunks.refreshMailList({ showLoading: false }));
                const sType = mailSearchStateMap[account] || 'local';
                trackApi.track('pcMail_executeMailSearch', {
                    searchMode: `全文搜索（${sType === 'local' ? '本地' : '云端'}）`,
                });
            }
        }
    }, 300, {
        leading: true,
        trailing: true,
    }), [isSearching, expandedSearchKeys, mailSearchStateMap]);
    const handleMailDropFolder = useCallback(e => {
        var _a, _b;
        const { event, node = {} } = e;
        let hasEml = dragTransFileHasEml(event);
        if (hasEml) {
            const mailBoxId = (_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId;
            handleEmlDrop(event, mailBoxId, node === null || node === void 0 ? void 0 : node._account);
        }
        else {
            const mailBoxId = (_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId;
            handleTreeItemDrop(event, mailBoxId, node === null || node === void 0 ? void 0 : node._account);
        }
    }, [handleEmlDrop, handleTreeItemDrop]);
    const handleMailDropFolderRef = useCreateCallbackForEvent(handleMailDropFolder);
    const handleStarFolderEditClick = useCallback((node) => {
        jumpToContactPersonalMark();
    }, []);
    const handleStarFolderEditClickRef = useCreateCallbackForEvent(handleStarFolderEditClick);
    const handleStarFolderAddClick = useCallback((node) => {
        trackApi.track('pcMail_click_addStarContact', { source: '文件夹列表添加星标按钮' });
        setAddContactModelVisiable(true);
    }, []);
    const handleStarFolderAddClickRef = useCreateCallbackForEvent(handleStarFolderAddClick);
    const handleDeleteFolder = useCallback((node) => {
        let mailTotal = 0;
        if (node) {
            treeDFS(node, item => {
                mailTotal += item.entry.mailBoxTotal;
            });
        }
        if (mailTotal > 0) {
            const al = Alert.info({
                title: getIn18Text('QINGXIANQINGKONGGAI'),
                funcBtns: [
                    {
                        text: getIn18Text('ZHIDAOLE'),
                        type: 'primary',
                        onClick: () => {
                            al.destroy();
                        },
                    },
                ],
            });
        }
        else {
            let childsHasActiveNode = false;
            treeDFS(node, (item) => {
                if (selectedKeys && item.entry.mailBoxId === selectedKeys.id) {
                    childsHasActiveNode = true;
                }
            });
            if (childsHasActiveNode) {
                const accountId = node === null || node === void 0 ? void 0 : node._account;
                setSelectedKeys({
                    id: 1,
                    accountId,
                });
            }
            return dispatch(Thunks.deleteUserFolder({
                mailIds: [node.mailBoxId],
                accountId: node._account,
            })).unwrap();
        }
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id]);
    const handleDeleteFolderRef = useCreateCallbackForEvent(handleDeleteFolder);
    const handleMultFolderSelect = useCallback((folder, accountTreeData) => {
        const fid = folder.entry.mailBoxId;
        if (fid == FLOLDER.STAR || folderIdIsContact(fid)) {
            setShowStarFolderTag(false);
        }
        if (fid === FLOLDER.STAR && folder.children && folder.children.length > 0) {
            let expandkeys = [...accountTreeData.expandedKeys];
            if (expandkeys.includes(FLOLDER.STAR)) {
                expandkeys = expandkeys.filter(item => item != FLOLDER.STAR);
            }
            else {
                expandkeys.push(FLOLDER.STAR);
            }
            expandFolder(expandkeys, accountTreeData.accountId);
        }
        else {
            handleSwitchFolder(folder);
            handleSwitchTab(folder);
        }
    }, [handleSwitchFolder, handleSwitchTab]);
    const handleMultFolderSelectRef = useCreateCallbackForEvent(handleMultFolderSelect);
    const handleFolderDrop = useCallback(e => {
        var _a, _b, _c, _d, _e;
        const { dragNode, node, dropToGap, dropPosition } = e;
        let _dropToGap = dropToGap;
        const nodeId = (_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId;
        const nodePid = ((_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b.pid) || 0;
        const dragNodeId = (_c = dragNode === null || dragNode === void 0 ? void 0 : dragNode.entry) === null || _c === void 0 ? void 0 : _c.mailBoxId;
        if (!_dropToGap && nodeId < 0 && nodePid == 0) {
            _dropToGap = true;
        }
        const treeMap = getTreeStatesByAccount(mailTreeStateMapRef.current, node._account);
        if (treeMap) {
            const mailTreeList = treeMap.mailFolderTreeList;
            if (validateFolderOperForNode(mailTreeList, node, dragNode, _dropToGap, dropPosition)) {
                const systemFolderIdList = [];
                mailTreeList.forEach(node => {
                    var _a, _b;
                    const pid = ((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.pid) || 0;
                    const folderId = (_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId;
                    if (pid == 0) {
                        systemFolderIdList.push(folderId);
                    }
                });
                let idList = [];
                const id = _dropToGap ? nodePid : nodeId;
                idList = id === 0 ? systemFolderIdList : ((_e = (_d = getTreeNodeById(mailTreeList, id)) === null || _d === void 0 ? void 0 : _d.children) === null || _e === void 0 ? void 0 : _e.map(item => item.entry.mailBoxId)) || [];
                idList = [...new Set([...idList.filter(item => item !== dragNodeId)])];
                let nodeIdIndex = idList.findIndex(folderId => folderId === nodeId) || 0;
                if (!(dropPosition && dropPosition < 0)) {
                    nodeIdIndex += 1;
                }
                idList.splice(nodeIdIndex, 0, dragNodeId);
                dispatch(Thunks.moveSortUserFolder({
                    id: dragNodeId,
                    parent: id,
                    sorts: idList,
                    accountId: node === null || node === void 0 ? void 0 : node._account,
                }));
            }
        }
    }, []);
    const handleFolderDropRef = useCreateCallbackForEvent(handleFolderDrop);
    const expandFolder = useCallback((keys, accountId) => {
        const numberKeys = folderId2Number(keys);
        setTreeState({
            accountId,
            name: 'expandedKeys',
            value: numberKeys,
        });
    }, []);
    const revalidateAccountFromPanel = (params) => {
        const { accountType, agentEmail, agentNickname } = params;
        if (loginingSubAccountList.includes(agentEmail))
            return;
        unstable_batchedUpdates(() => {
            setMultAccountsLoginVisible(true);
            setMultAccountsLoginInfo({
                type: 'rebind',
                way: 'mailList',
                accountType,
                agentEmail,
                agentNickname,
            });
        });
    };
    const revalidateAccount = (accountData) => {
        const { emailType, accountId, accountName } = accountData;
        if (loginingSubAccountList.includes(accountId))
            return;
        setMultAccountsLoginVisible(true);
        setMultAccountsLoginInfo({
            type: 'rebind',
            way: 'mailList',
            accountType: ['NeteaseQiYeMail', 'qyEmail'].includes(emailType) ? 'NeteaseQiYeMail' : emailType,
            agentEmail: accountId,
            agentNickname: accountName || accountId,
        });
    };
    const closeMultAccountsModal = () => {
        setMultAccountsLoginVisible(false);
    };
    const onMultAccountFolderExpand = useCallback((keys) => {
        if (activeKey.length < keys.length) {
            const latestedKey = keys[keys.length - 1];
            if (expiredAccountList.includes(latestedKey)) {
                const latestedAccount = maiTreeStateList.find(item => {
                    return (item === null || item === void 0 ? void 0 : item.accountId) === latestedKey;
                });
                if (latestedAccount) {
                    revalidateAccount(latestedAccount);
                }
            }
        }
        setActiveKey(keys);
    }, [activeKey, expiredAccountList]);
    const folderAllowDrop = useCallback((dropNode, dragNode) => {
        var _a, _b, _c;
        if (dragNode) {
            const dragKey = dragNode === null || dragNode === void 0 ? void 0 : dragNode.mailBoxId;
            const dragNodeIsRealSystem = isSystemFolder(dragKey) && folderIdIsRealFolder(dragKey);
            if (dragNodeIsRealSystem) {
                return ((_a = dropNode === null || dropNode === void 0 ? void 0 : dropNode.entry) === null || _a === void 0 ? void 0 : _a._deep) <= 1 && !folderIdIsContact((_b = dropNode === null || dropNode === void 0 ? void 0 : dropNode.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId);
            }
        }
        return !folderIdIsContact((_c = dropNode === null || dropNode === void 0 ? void 0 : dropNode.entry) === null || _c === void 0 ? void 0 : _c.mailBoxId);
    }, []);
    const folderDragAble = useCallback((node) => {
        return !folderIdIsContact(node === null || node === void 0 ? void 0 : node.mailBoxId);
    }, []);
    const folderOperBtnVisibility = useCallback((node, defaultfn) => {
        let defaultVisibility = false;
        const key = (node === null || node === void 0 ? void 0 : node.mailBoxId) || '';
        if (folderIdIsContact(key)) {
            return false;
        }
        if (defaultfn && typeof defaultfn === 'function') {
            defaultVisibility = defaultfn(node);
        }
        return defaultVisibility;
    }, []);
    const folderOuterAllowDrop = useCallback(node => {
        if (node && ((node === null || node === void 0 ? void 0 : node.mailBoxId) === FLOLDER.STAR || folderIdIsContact(node === null || node === void 0 ? void 0 : node.mailBoxId))) {
            return false;
        }
        return (node === null || node === void 0 ? void 0 : node.mailBoxId) > 0;
    }, []);
    const fodlerEmlAllowDrop = useCallback(node => {
        return folderIdIsRealFolder(node === null || node === void 0 ? void 0 : node.mailBoxId);
    }, []);
    const MainFolderTreeOuterDropRule = useCallback((mailIsCurTree) => {
        if (isDragModel == 'eml') {
            return fodlerEmlAllowDrop;
        }
        else if (mailIsCurTree) {
            return folderOuterAllowDrop;
        }
        return false;
    }, [isDragModel, fodlerEmlAllowDrop]);
    const folderOperBtnRender = useCallback((node) => {
        const key = node === null || node === void 0 ? void 0 : node.mailBoxId;
        if (key == FLOLDER.STAR) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Tooltip, { title: getIn18Text('TIANJIA'), trigger: ['hover'] },
                    React.createElement("div", { className: "more", "data-test-id": "mail-start-contact-add-btn", onClick: () => handleStarFolderAddClickRef(node) },
                        React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("path", { d: "M3 8H13M8 13L8 3", stroke: "#6F7485", "stroke-linecap": "round" })))),
                React.createElement(Tooltip, { title: getIn18Text('GUANLI'), trigger: ['hover'] },
                    React.createElement("div", { className: "more", "data-test-id": "mail-start-contact-manage-btn", onClick: () => handleStarFolderEditClickRef(node) },
                        React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("circle", { cx: "7.99992", cy: "7.99967", r: "1.66667", stroke: "#6F7485", "stroke-width": "1.2", "stroke-linecap": "round" }),
                            React.createElement("path", { d: "M7.49975 2.04063C7.80915 1.862 8.19034 1.862 8.49975 2.04063L12.9107 4.5873C13.2201 4.76593 13.4107 5.09606 13.4107 5.45332V10.5467C13.4107 10.9039 13.2201 11.2341 12.9107 11.4127L8.49975 13.9594C8.19035 14.138 7.80915 14.138 7.49975 13.9594L3.08879 11.4127C2.77939 11.2341 2.58879 10.9039 2.58879 10.5467V5.45332C2.58879 5.09606 2.77939 4.76593 3.08879 4.5873L7.49975 2.04063Z", stroke: "#6F7485", "stroke-linecap": "round", "stroke-linejoin": "round" }))))));
        }
    }, []);
    const handleFolderSort = useCallback((node) => {
        try {
            const { _account, entry } = node;
            const isMainAcc = isMainAccount(_account);
            let treeState = null;
            treeState = getTreeStatesByAccount(mailTreeStateMapRef.current, _account);
            if (!treeState) {
                Message.error({ content: getIn18Text('PAIXUSHIBAI') });
                return;
            }
            let parentId = null;
            let folders = undefined;
            if (entry._deep === 1) {
                parentId = 0;
                folders = treeState === null || treeState === void 0 ? void 0 : treeState.mailFolderTreeList;
            }
            else {
                const parent = getParentNodeById(treeState.mailFolderTreeList, node.entry.mailBoxId);
                parentId = parent === null || parent === void 0 ? void 0 : parent.entry.mailBoxId;
                folders = parent === null || parent === void 0 ? void 0 : parent.children;
            }
            if (!(folders === null || folders === void 0 ? void 0 : folders.length)) {
                Message.error({ content: getIn18Text('PAIXUSHIBAI') });
                return;
            }
            setFolderSortModalData({
                parentId,
                folders,
                accountId: _account,
            });
            setFolderSortModalVisiable(true);
        }
        catch (error) {
            console.log('排序失败', error);
        }
    }, []);
    const folderMenu = useCallback((node) => {
        var _a, _b, _c, _d, _e, _f;
        const isCustom = isCustomFolder((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId);
        const showExtraFolderOper = isCustom;
        const fid = (_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId;
        const isRealFolder = folderIdIsRealFolder(fid);
        const isMainAcc = isMainAccount(node._account);
        let showAllRead = false;
        let showImportEmls = isRealFolder;
        let total = 0;
        let unread = 0;
        const isThread = mailConfigStateIsMerge();
        const curUser = systemApi.getCurrentUser();
        total = isThread ? (_c = node === null || node === void 0 ? void 0 : node.entry) === null || _c === void 0 ? void 0 : _c.threadMailBoxTotal : (_d = node === null || node === void 0 ? void 0 : node.entry) === null || _d === void 0 ? void 0 : _d.mailBoxTotal;
        unread = isThread ? (_e = node === null || node === void 0 ? void 0 : node.entry) === null || _e === void 0 ? void 0 : _e.threadMailBoxCurrentUnread : (_f = node === null || node === void 0 ? void 0 : node.entry) === null || _f === void 0 ? void 0 : _f.mailBoxCurrentUnread;
        if (folderIdIsContact(fid)) {
            return React.createElement(React.Fragment, null);
        }
        if ((fid < 2 || fid > 5) && fid !== 7 && unread && fid != FLOLDER.STAR && fid != FLOLDER.DEFER) {
            showAllRead = true;
        }
        const itemList = [];
        if (showAllRead) {
            itemList.push(React.createElement(Menu.Item, { key: "2", "data-test-id": "folder-setting-all-read", onClick: () => {
                    SiriusModal.confirm({
                        title: getIn18Text('markAllConfirm'),
                        hideCancel: true,
                        okText: getIn18Text('QUEREN'),
                        okButtonProps: { danger: true, type: 'default' },
                        onOk: () => {
                            handleAllRead(fid, node._account);
                            handleFolderTreeMenuClick();
                        },
                        onCancel: () => { },
                    });
                } }, getIn18Text('QUANBIAOYIDU')));
            itemList.push(React.createElement(Menu.Divider, null));
        }
        if (isFollowFolder(fid)) {
            itemList.push(React.createElement(Menu.Item, { key: "2", "data-test-id": "folder-setting-all-followup", onClick: () => {
                    SiriusModal.confirm({
                        title: isUnFollowFolder(fid) ? getIn18Text('SHIFOUJIANGSYWDDGJYJ5') : getIn18Text('SHIFOUJIANGSYYDDGJYJ5'),
                        hideCancel: true,
                        okText: getIn18Text('QUEREN'),
                        okButtonProps: { danger: true, type: 'default' },
                        onOk: () => {
                            handleAllFollow(fid, node._account);
                            handleFolderTreeMenuClick();
                        },
                        onCancel: () => { },
                    });
                } }, getIn18Text('QUANBIAOYIGJ')));
            itemList.push(React.createElement(Menu.Divider, null));
        }
        if (total) {
            itemList.push(React.createElement(Menu.Item, { key: "5", "data-test-id": "folder-setting-empty", onClick: async () => {
                    const banDel = await mailConfApi.getAccountBanSetting(node._account).then(res => res.ban_del_mail);
                    if (banDel) {
                        Message.warn(getIn18Text('MEIYOUSHANCHUQUANXIAN，'));
                        return;
                    }
                    if (fid != null) {
                        setDialog(getDeletDialogConfig(node));
                        setModalVisible(true);
                    }
                    handleFolderTreeMenuClick();
                } }, fid === 4 ? getIn18Text('CHEDIQINGKONGWEN') : getIn18Text('QINGKONGWENJIANJIA')));
        }
        itemList.push(React.createElement(Menu.Item, { key: "0", "data-test-id": "folder-setting-create", onClick: () => {
                try {
                    const res = getMapConfigBySameAccountKey(folderRefMap === null || folderRefMap === void 0 ? void 0 : folderRefMap.current, node._account + '');
                    if (res) {
                        res === null || res === void 0 ? void 0 : res.appendFolder();
                    }
                }
                catch (e) {
                    console.warn('mail folder oper err', e);
                }
                handleFolderTreeMenuClick();
            } }, getIn18Text('XINJIANWENJIANJIA')));
        itemList.push(React.createElement(Menu.Divider, null));
        if (fid > 0) {
            itemList.push(React.createElement(Menu.Item, { key: "1", "data-test-id": "folder-setting-create-child", onClick: () => {
                    try {
                        const res = getMapConfigBySameAccountKey(folderRefMap === null || folderRefMap === void 0 ? void 0 : folderRefMap.current, node._account + '');
                        if (res) {
                            res === null || res === void 0 ? void 0 : res.addFolder();
                        }
                    }
                    catch (e) {
                        console.warn('mail folder oper err', e);
                    }
                    handleFolderTreeMenuClick();
                } }, getIn18Text('XINJIANZIWENJIAN')));
            itemList.push(React.createElement(Menu.Divider, null));
        }
        if (showExtraFolderOper) {
            itemList.push(React.createElement(Menu.Item, { key: "3", "data-test-id": "folder-setting-rename", onClick: () => {
                    try {
                        const res = getMapConfigBySameAccountKey(folderRefMap === null || folderRefMap === void 0 ? void 0 : folderRefMap.current, node._account + '');
                        if (res) {
                            res === null || res === void 0 ? void 0 : res.updateFolder();
                        }
                    }
                    catch (e) {
                        console.warn('mail folder oper err', e);
                    }
                    handleFolderTreeMenuClick();
                } }, getIn18Text('ZHONGMINGMING')));
            itemList.push(React.createElement(Menu.Divider, null));
            itemList.push(React.createElement(Menu.Item, { key: "4", "data-test-id": "folder-setting-move", onClick: () => {
                    handleMoveFolder(node);
                    handleFolderTreeMenuClick();
                } }, getIn18Text('YIDONGZHI')));
            itemList.push(React.createElement(Menu.Divider, null));
        }
        const notAllowFid = [FLOLDER.SENT, FLOLDER.WAITINGISSUE, FLOLDER.READYISSUE, FLOLDER.EDM_OTHER_REPLY, FLOLDER.EDM_REPLY];
        if (!isCorpMail && (isCustom || (fid > 0 && !notAllowFid.includes(+fid)))) {
            itemList.push(React.createElement(Menu.Item, { key: "7", "data-test-id": "folder-setting-income-mail", onClick: () => {
                    openMailSetting(node._account, fid);
                    handleFolderTreeMenuClick();
                } }, getIn18Text('SHEZHILAIXINFEN')));
            itemList.push(React.createElement(Menu.Divider, null));
        }
        if (showExtraFolderOper) {
            itemList.push(React.createElement(Menu.Item, { key: "6", "data-test-id": "folder-setting-delete", onClick: () => {
                    try {
                        const res = getMapConfigBySameAccountKey(folderRefMap === null || folderRefMap === void 0 ? void 0 : folderRefMap.current, node._account + '');
                        if (res) {
                            res === null || res === void 0 ? void 0 : res.deleteFolder();
                        }
                    }
                    catch (e) {
                        console.warn('mail folder oper err', e);
                    }
                    handleFolderTreeMenuClick();
                } }, getIn18Text('SHANCHU')));
            itemList.push(React.createElement(Menu.Divider, null));
        }
        if (showImportEmls) {
            itemList.push(React.createElement(Menu.Item, { key: "8", "data-test-id": "folder-setting-import-mail", onClick: () => {
                    var _a;
                    try {
                        handleImportFolder(node);
                        if (inElectron) {
                            importMails({ fid: node.entry.mailBoxId, _account: node._account }).then(() => {
                                dispatch(Thunks.refreshMailList({
                                    noCache: true,
                                    showLoading: false,
                                }));
                            });
                        }
                        else {
                            _uploadFileRef.current && ((_a = _uploadFileRef.current) === null || _a === void 0 ? void 0 : _a.click());
                        }
                    }
                    catch (e) {
                        console.warn('mail folder oper err', e);
                    }
                    handleFolderTreeMenuClick();
                } }, getIn18Text('DAORUYOUJIAN')));
            itemList.push(React.createElement(Menu.Divider, null));
        }
        itemList.push(React.createElement(Menu.Item, { "data-test-id": "folder-setting-sort", key: "9", onClick: () => handleFolderSort(node) }, getIn18Text('WENJIANJIAPAIXU')));
        itemList.push(React.createElement(Menu.Divider, null));
        itemList.pop();
        return itemList.length ? React.createElement(Menu, null, itemList) : React.createElement(React.Fragment, null);
    }, [handleAllRead, handleFolderTreeMenuClick, getDeletDialogConfig, handleMoveFolder, openMailSetting, handleImportFolder]);
    const getFolderMenu = useCallback((data) => {
        if (data) {
            return folderMenu(data);
        }
        return React.createElement(React.Fragment, null);
    }, [folderMenu]);
    const getFolderMenuRef = useCreateCallbackForEvent(getFolderMenu);
    const renderTreeMainAccount = useCallback((accountTreeData) => {
        const mailIsCurTree = accountApi.getIsSameSubAccountSync(accountTreeData.accountId, folderTreeDragModel === null || folderTreeDragModel === void 0 ? void 0 : folderTreeDragModel.accountId);
        const isCurTree = isMainAccount(selectedKeys.accountId);
        const wmReplyShowTip = false;
        return (React.createElement(React.Fragment, null,
            React.createElement(FolderTree, { ref: folderRef => {
                    folderRefMap.current[accountTreeData.accountId] = folderRef;
                }, data: accountTreeData.mailFolderTreeList, expandedKeys: folderId2String(accountTreeData.expandedKeys), onExpand: (keys, { node, expanded }) => {
                    expandFolder(keys, accountTreeData.accountId);
                }, editAble: true, dragModel: isDragModel ? 'drag' : 'move', selectedKey: folderTreeDragModel || curTabIsReadTab ? null : isCurTree ? selectedKeys.id : null, isOuterDrag: !!isDragModel, menu: getFolderMenuRef, onAddFolder: (data, keyList) => {
                    var _a;
                    return dispatch(Thunks.createUserFolder([
                        {
                            parent: data.entry.pid,
                            name: data.entry.mailBoxName,
                            accountId: data === null || data === void 0 ? void 0 : data._account,
                            _tempId: (_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId,
                            sort: keyList,
                        },
                    ])).unwrap();
                }, onUpdateFolder: (data) => dispatch(Thunks.updateUserFolder([
                    {
                        id: data.entry.mailBoxId,
                        parent: data.entry.pid,
                        name: data.entry.mailBoxName,
                        accountId: data === null || data === void 0 ? void 0 : data._account,
                    },
                ])).unwrap(), onDeleteFolder: handleDeleteFolderRef, onDrop: handleFolderDropRef, onOuterDrop: handleMailDropFolderRef, onNodeTitleClick: (folder) => {
                    if ((folder === null || folder === void 0 ? void 0 : folder.mailBoxId) == (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
                        setSelected('ALL');
                    }
                }, onSelect: (folder) => {
                    handleMultFolderSelectRef(folder, accountTreeData);
                }, wmReplyShowTip: wmReplyShowTip, showWmReplyGuide: activeKey.includes(accountTreeData.accountId), operBtnRender: folderOperBtnRender, operBtnVisibility: folderOperBtnVisibility, allowDrop: folderAllowDrop, draggable: folderDragAble, unReadRender: renderUnread, outerAllowDrop: MainFolderTreeOuterDropRule(mailIsCurTree) }),
            React.createElement("div", { "data-test-id": "mail-folder-add-btn", className: "add-folder-wrap", onClick: () => {
                    var _a;
                    (_a = folderRefMap.current[accountTreeData.accountId]) === null || _a === void 0 ? void 0 : _a.addFolder();
                } },
                React.createElement("div", { className: "add-folder-icon" }),
                React.createElement("div", { className: "add-folder-name" }, getIn18Text('XINJIANWENJIANJIA'))),
            !mainMailHasCustomFolder ? (React.createElement("div", { className: "ct-folder-emptytip" },
                getIn18Text('ZIDINGYIZHUANSHU'),
                React.createElement("div", { className: "create-entry", onClick: () => {
                        var _a;
                        (_a = folderRefMap.current[accountTreeData.accountId]) === null || _a === void 0 ? void 0 : _a.addFolder();
                    } }, getIn18Text('XINJIANWENJIANJIA')))) : (''),
            React.createElement(MailTag, { scrollController: treeContainerScrollController, activeName: tagName, disabled: isMailDraging })));
    }, [
        folderTreeDragModel,
        curTabIsReadTab,
        isDragModel,
        selectedKeys,
        MainFolderTreeOuterDropRule,
        renderUnread,
        `${tagName === null || tagName === void 0 ? void 0 : tagName.key}${tagName === null || tagName === void 0 ? void 0 : tagName.accountId}`,
        isMailDraging,
        activeKey.length,
    ]);
    const renderTreeDomNotMainAccount = useCallback((accountTreeData) => {
        const mailIsCurTree = accountApi.getIsSameSubAccountSync(accountTreeData.accountId, folderTreeDragModel === null || folderTreeDragModel === void 0 ? void 0 : folderTreeDragModel.accountId);
        const isCurTree = accountApi.getIsSameSubAccountSync(selectedKeys.accountId, accountTreeData === null || accountTreeData === void 0 ? void 0 : accountTreeData.accountId);
        if (loginingSubAccountList.includes(accountTreeData.accountId)) {
            return (React.createElement("div", { style: {
                    lineHeight: '20px',
                    fontSize: '12px',
                    color: '#7d8085',
                    paddingLeft: '30px',
                } }, getIn18Text('ACCOUNT_LOADING_TIP')));
        }
        if (accountTreeData.expired) {
            return (React.createElement("div", { style: {
                    lineHeight: '20px',
                    fontSize: '12px',
                    color: '#7d8085',
                    paddingLeft: '30px',
                } },
                "\u8D26\u53F7\u5931\u6548\uFF0C\u8BF7",
                React.createElement("span", { onClick: () => revalidateAccount(accountTreeData), style: { color: '#5383fe', cursor: 'pointer' } }, "\u91CD\u65B0\u9A8C\u8BC1")));
        }
        const wmReplyShowTip = false;
        return (React.createElement(React.Fragment, null,
            React.createElement(FolderTree, { ref: folderRef => {
                    folderRefMap.current[accountTreeData.accountId] = folderRef;
                }, data: accountTreeData.mailFolderTreeList, expandedKeys: folderId2String(accountTreeData.expandedKeys), onExpand: keys => {
                    expandFolder(keys, accountTreeData.accountId);
                }, isMerge: false, editAble: true, selectedKey: folderTreeDragModel || curTabIsReadTab ? null : isCurTree ? selectedKeys.id : null, dragModel: isDragModel ? 'drag' : 'move', isOuterDrag: !!isDragModel, onSelect: (folder) => {
                    handleMultFolderSelectRef(folder, accountTreeData);
                }, wmReplyShowTip: wmReplyShowTip, outerAllowDrop: MainFolderTreeOuterDropRule(mailIsCurTree), menu: getFolderMenuRef, onAddFolder: (data, keyList) => {
                    var _a;
                    return dispatch(Thunks.createUserFolder([
                        {
                            parent: data.entry.pid,
                            name: data.entry.mailBoxName,
                            accountId: data._account,
                            _tempId: (_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId,
                            sort: keyList,
                        },
                    ])).unwrap();
                }, onUpdateFolder: (data) => dispatch(Thunks.updateUserFolder([
                    {
                        id: data.entry.mailBoxId,
                        parent: data.entry.pid,
                        name: data.entry.mailBoxName,
                        accountId: data._account,
                    },
                ])).unwrap(), onDeleteFolder: handleDeleteFolderRef, onDrop: handleFolderDropRef, onOuterDrop: handleMailDropFolderRef, unReadRender: renderUnread }),
            React.createElement("div", { className: "add-folder-wrap", onClick: () => {
                    var _a;
                    (_a = folderRefMap.current[accountTreeData.accountId]) === null || _a === void 0 ? void 0 : _a.addFolder();
                } },
                React.createElement("div", { className: "add-folder-icon" }),
                React.createElement("div", { className: "add-folder-name" }, getIn18Text('XINJIANWENJIANJIA'))),
            React.createElement(MailTag, { account: accountTreeData.accountId, scrollController: treeContainerScrollController, activeName: tagName, disabled: isMailDraging })));
    }, [
        folderTreeDragModel,
        curTabIsReadTab,
        selectedKeys,
        isDragModel,
        MainFolderTreeOuterDropRule,
        renderUnread,
        `${tagName === null || tagName === void 0 ? void 0 : tagName.key}${tagName === null || tagName === void 0 ? void 0 : tagName.accountId}`,
        loginingSubAccountList,
    ]);
    const renderTreeData = useMemo(() => {
        const dataList = maiTreeStateList.map((accountTreeData, idx) => {
            const { accountId, accountName, emailType, count, expired, initLoading } = accountTreeData;
            return {
                key: accountId,
                title: accountName,
                count: count > 999 ? '999+' : count + '',
                type: emailType,
                expired: expired || expiredAccountList.includes(accountId),
                isLogining: loginingSubAccountList.includes(accountId) || initLoading,
                children: idx === 0 ? renderTreeMainAccount(accountTreeData) : renderTreeDomNotMainAccount(accountTreeData),
            };
        });
        return dataList;
    }, [maiTreeStateList, renderTreeMainAccount, renderTreeDomNotMainAccount, loginingSubAccountList]);
    const renderTreeDomElement = useMemo(() => {
        return (React.createElement(SiriusCollapse, { activeKey: activeKey, defaultActiveKey: activeKey, activeAccount: folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) ? undefined : selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, changeCb: keys => onMultAccountFolderExpand(keys), dataList: renderTreeData, revalidateAccountFromPanel: revalidateAccountFromPanel, source: "folder" }));
    }, [renderTreeData, activeKey, onMultAccountFolderExpand, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId]);
    useEffect(() => {
        var _a;
        try {
            const mainMailFolderList = (_a = mailTreeStateMap.main) === null || _a === void 0 ? void 0 : _a.mailFolderTreeList;
            if (mainMailFolderList && mainMailFolderList.length) {
                let hasCtFolder = false;
                treeDFS(mainMailFolderList, (folder) => {
                    if (folder.entry.mailBoxId && isCustomFolder(folder.entry.mailBoxId)) {
                        hasCtFolder = true;
                    }
                });
                setMailMailHasCtFolder(hasCtFolder);
            }
        }
        catch (error) {
            console.error('Error checking custom folders:', error);
        }
    }, [mailTreeStateMap]);
    useEffect(() => {
        if (mailUnReadSum != null) {
            dispatch(mailTabActions.doChangeTabById({
                id: '-1/-1',
                tabModel: {
                    id: '-1/-1',
                    extra: {
                        unRead: mailUnReadSum,
                    },
                },
            }));
        }
        else {
            dispatch(mailTabActions.doChangeTabById({
                id: '-1/-1',
                tabModel: {
                    id: '-1/-1',
                    extra: {
                        unRead: 0,
                    },
                },
            }));
        }
    }, [mailUnReadSum]);
    return (React.createElement("div", { ref: treeContainerRef, className: `${maiTreeStateList.length > 1 ? 'add-pdl ' : ''} ${className}` },
        renderTreeDomElement,
        React.createElement(MultAccountsLoginModal, { visible: multAccountsLoginVisible, loginInfo: multAccountsLoginInfo, closeModel: closeMultAccountsModal }),
        process.env.BUILD_ISEDM ? React.createElement(WmFolderSortModal, null) : React.createElement(FolderSortModal, null)));
};
export default MailFolders;
